import { render, staticRenderFns } from "./DropdownTreeItem.vue?vue&type=template&id=14655d67&scoped=true&"
import script from "./DropdownTreeItem.vue?vue&type=script&lang=js&"
export * from "./DropdownTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./DropdownTreeItem.vue?vue&type=style&index=0&id=14655d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14655d67",
  null
  
)

export default component.exports